import { useRef, useState } from "react";
import { ErrorsDisplay } from "../Shared/Error";
import { API_ChangePassword, PasswordResetRequestModel } from "../../../apis/ApisAuth";
import { Link } from "react-router-dom";
import { validatePassword } from "../../../helpers/passwordValidator";

export type PasswordResetProps = {
    uid: string,
    data: PasswordResetRequestModel
}
export function PasswordResetForm(props: PasswordResetProps) {
    const [id] = useState<string>(props.uid);
    const [newPassword, setNewPassword] = useState<string>('');
    const [newPasswordConfirm, setNewPasswordConfirm] = useState<string>('');
    const [updated, setUpdated] = useState<boolean>(false);
    const [errors, setErrors] = useState<string[]>([]);
    const inputRef = useRef<HTMLInputElement>(null);
    const inputRef2 = useRef<HTMLInputElement>(null);

    const tryChange = async () => {
        let errors: string[] = [];
        if (newPasswordConfirm == '' || newPasswordConfirm.length == 0) {
            inputRef2?.current?.classList.remove("is-valid");
            inputRef2?.current?.classList.add("is-invalid");
            errors = ([...errors, "Please provide a valid password confimation"]);
        }
        else {
            inputRef2?.current?.classList.add("is-valid");
            inputRef2?.current?.classList.remove("is-invalid");
        }

        if (newPassword == '' || newPassword.length == 0) {
            inputRef?.current?.classList.remove("is-valid");
            inputRef?.current?.classList.add("is-invalid");
            errors = ([...errors, "Please provide a valid password"]);
        }
        else {

            let passwordErrors = validatePassword(newPassword);
            errors = ([...errors, ...passwordErrors]);

            if (errors.length != 0) {
                inputRef2?.current?.classList.remove("is-valid");
                inputRef?.current?.classList.remove("is-valid");
                inputRef2?.current?.classList.add("is-invalid");
                inputRef?.current?.classList.add("is-invalid");
            }
            else {
                inputRef2?.current?.classList.add("is-valid");
                inputRef?.current?.classList.add("is-valid");
                inputRef2?.current?.classList.remove("is-invalid");
                inputRef?.current?.classList.remove("is-invalid");
            }
        }

        if (errors.length == 0 && newPasswordConfirm != newPassword) {
            inputRef2?.current?.classList.remove("is-valid");
            inputRef?.current?.classList.remove("is-valid");
            inputRef2?.current?.classList.add("is-invalid");
            inputRef?.current?.classList.add("is-invalid");
            errors = ([...errors, "Passwords must match"]);
        }
        else if (errors.length == 0) {
            inputRef2?.current?.classList.add("is-valid");
            inputRef?.current?.classList.add("is-valid");
            inputRef2?.current?.classList.remove("is-invalid");
            inputRef?.current?.classList.remove("is-invalid");

            var res = await API_ChangePassword(newPassword, newPasswordConfirm, id);

            if (res.Success) {
                setUpdated(true);
            }
            else {
                errors = ([...errors, res.Error]);
            }
        }

        setErrors(errors);
    }

    return (
        <>
            {updated && <>
                <div className="alert alert-success mb-0">
                    Password changed. Please return to the <Link className="secondary-link" to="/">home page</Link> and log in again
                </div>
            </>}
            {!props.data.ValidID && <div className="alert alert-danger">
                The link you have clicked has already been used to change your password or multiple requests for new passwords have been made and this link is out of date.
                If a later email has been received, try the link in that, otherwise, go to the login page and request a new change password link.
            </div>}
            {props.data.ValidID && !updated &&
                <form className="flex-column gap-3" role="password-recovery">
                    <div className="alert alert-info">{props.data.Requirements}</div>
                    <ErrorsDisplay errors={errors} />
                    <div className="col-auto">
                        <label htmlFor="passwordontrol" className="form-label-alt">Password</label>
                        <input ref={inputRef} id="passwordontrol" className="form-control"
                            value={newPassword}
                            required
                            type="password"
                            onChange={t => {
                                setNewPassword(t.currentTarget.value);
                                inputRef?.current?.classList.remove("is-valid");
                                inputRef?.current?.classList.remove("is-invalid");
                            }} />
                        <div className="invalid-feedback">
                            Please provide a valid password
                        </div>
                    </div>
                    <div className="col-auto">
                        <label htmlFor="confirmpasswordontrol" className="form-label-alt">Confirm password</label>
                        <input ref={inputRef2} id="confirmpasswordontrol" className="form-control"
                            value={newPasswordConfirm}
                            required
                            type="password"
                            onChange={t => {
                                setNewPasswordConfirm(t.currentTarget.value);
                                inputRef2?.current?.classList.remove("is-valid");
                                inputRef2?.current?.classList.remove("is-invalid");
                            }} />
                        <div className="invalid-feedback">
                            Please provide a valid password confirmation
                        </div>
                    </div>
                    <div className="text-center">
                        <button className="btn btn-alt mt-3 btn-wider" type="submit" onClick={e => {
                            e.preventDefault();
                            tryChange();
                        }}>Change</button>
                    </div>
                </form>
            }
        </>
    );
}